

import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppWrapper from "./AppWrapper"; // We moved logic to separate file
import "./index.css";

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
